import { connect } from 'react-redux';
import View from './XMobileNavigationView';
import { hideSelector } from './XMobileNavigationSelector';
import {
  hasTakeMeToDashboardSelector,
  hasAddAnotherGoalSelector,
} from '../AdvWorkflow/AdvWorkflowSelector';
import { isConsumerArea } from '../../CommonSelectors/CommonAreaSelector';

const mapStateToProps = (state, ownProps) => ({
  hide:
    hideSelector(state, ownProps) || !isConsumerArea(state) ||
    !(hasTakeMeToDashboardSelector(state) || hasAddAnotherGoalSelector(state)),
});

const mapDispatchToProps = () => ({
  onClick: () => window.history.back(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
